import React, { Component } from "react";

import {
    AudioPlayer,
    DistroVideos,
    DonateBtns,
    Logo,
    SongList,
} from "../components";
import { DEFAULT_SONG, originals, covers, collabs } from "../content/songs";
import SoundCloudLogo from "../images/logos/soundcloud.svg";
import Thumb from "../images/logos/thumb.svg";
import "./Music.css";

const thumbStyle = {
    cursor: "pointer",
    marginBottom: "-8px",
    marginLeft: "5px",
    maxHeight: "30px",
    maxWidth: "100%",
};

class Music extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: DEFAULT_SONG,
            autoPlay: false,
            askForTip: false,
            screenWidth: null,
        };
    }

    componentDidMount = () => {
        if (
            window.location.protocol !== "https:" &&
            window.location.hostname !== "localhost"
        ) {
            window.location.href =
                "https:" +
                window.location.href.substring(window.location.protocol.length);
        }
    };

    toggleAutoPlay = () => {
        this.setState({
            autoPlay: !this.state.autoPlay,
        });
    };

    toggleTip = () => {
        this.setState({
            askForTip: true,
        });
    };

    setTitle = (title) => {
        this.setState({
            title,
        });
    };

    render() {
        const { title, autoPlay, askForTip } = this.state;
        return (
            <div className="container music-container">
                <div className="row row-style justify-content-center text-center">
                    <p className="title large-title">MUSIC</p>
                    <p className="description text-left">
                        Music has been in my life thanks to my mother and
                        father. There was always music in my home, either with
                        singing or just music on records or the radio. Dad liked
                        big band music and quirky, novelty music, from
                        performers such as Spike Jones and Stan Freberg. Mom
                        loved old time hymns and church choral music with vocal
                        harmonies.
                    </p>
                    <div className="spacer"></div>
                </div>

                <div className="distroVideosContainer">
                    <DistroVideos />
                </div>

                <div className="scLogoContainer">
                    <img
                        alt="SoundCloud Logo"
                        className="scLogo"
                        src={SoundCloudLogo}
                    />
                </div>

                <div className="row" />
                <div>
                    <div
                        id="audio-section"
                        className={`row row-style justify-content-center text-center audio-section`}
                    >
                        <div className="autoPlaySwitch">
                            <p className="autoPlayLabel">AUTOPLAY</p>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    onChange={this.toggleAutoPlay}
                                />
                                <span className="slider round" />
                            </label>
                        </div>
                        <AudioPlayer title={title} autoPlay={autoPlay} />
                    </div>

                    <div className="donatePrompt text-center">
                        {!askForTip ? (
                            <div
                                className="likeThisSong"
                                onClick={this.toggleTip}
                            >
                                <Logo image={Thumb} style={thumbStyle} />
                                Like this song?
                            </div>
                        ) : (
                            <div className="leaveATip fadeIn-fast">
                                <p className="description">Leave a tip!</p>
                                <DonateBtns />
                            </div>
                        )}
                    </div>
                </div>

                <div className="row row-style justify-content-center text-center songListRow">
                    {Object.entries(originals).length > 0 ? (
                        <SongList
                            listTitle={"Originals"}
                            list={originals}
                            selectedTitle={title}
                            setTitle={this.setTitle}
                        />
                    ) : (
                        <></>
                    )}

                    {Object.entries(covers).length > 0 ? (
                        <SongList
                            listTitle={"Covers"}
                            list={covers}
                            selectedTitle={title}
                            setTitle={this.setTitle}
                        />
                    ) : (
                        <></>
                    )}

                    {Object.entries(collabs).length > 0 ? (
                        <SongList
                            listTitle={"Collaborations"}
                            list={collabs}
                            selectedTitle={title}
                            setTitle={this.setTitle}
                        />
                    ) : (
                        <></>
                    )}
                </div>
            </div>
        );
    }
}

export default Music;
